<template>
    <div class="main">
        <c-panel title="REQUISIÇÕES" titleIcon="fas fa-file-signature">
            <el-form label-position="top">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="24" v-if="ehSmed">
                        <el-form-item label="Solicitante">
                            <el-select v-model="filtro.instituicao_id" placeholder="Todas" filterable clearable
                                style="width:100%;" @change="load(1)">
                                <el-option v-for="i in listaInstituicoes" :key="i.id" :label="i.nome" :value="i.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24" :md="4">
                        <el-form-item label="Situação">
                            <el-select v-model="filtro.status" placeholder="Todas" clearable style="width:100%;" @change="load(1)">
                                <el-option label="Aberta" :value="1"></el-option>
                                <el-option label="Atendida" :value="2"></el-option>
                                <el-option label="Cancelada" :value="3"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="4">
                        <el-form-item label="De">
                            <el-date-picker v-model="filtro.data_inicio" type="date" format="dd/MM/yyyy"
                                value-format="yyyy-MM-dd" style="width:100%;" @change="load(1)"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="4">
                        <el-form-item label="Até">
                            <el-date-picker v-model="filtro.data_fim" type="date" format="dd/MM/yyyy"
                                value-format="yyyy-MM-dd" style="width:100%;" @change="load(1)"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" class="u-text-right" style="padding-top: 30px;">
                        <router-link to="/admin/almox-requisicao/cadastro">
                            <el-button type="primary" icon="el-icon-plus">NOVA REQUISIÇÃO</el-button>
                        </router-link>
                    </el-col>
                </el-row>
            </el-form>

            <div class="container-table" v-loading="!statusList">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th style="width:170px;">Número</th>
                            <th style="width:100px;">Data</th>
                            <th>Solicitante</th>
                            <th style="width:70px;" class="u-text-center">Itens</th>
                            <th style="width:110px;" class="u-text-center">Situação</th>
                            <th style="width:200px;" class="u-text-center">Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="r in items" :key="r.id">
                            <td>{{ r.numero }}</td>
                            <td>{{ formataData(r.data_requisicao) }}</td>
                            <td>{{ r.instituicao ? r.instituicao.nome : '—' }}</td>
                            <td class="u-text-center">{{ r.itens ? r.itens.length : 0 }}</td>
                            <td class="u-text-center">
                                <el-tag size="mini" :type="corStatus(r.status)">{{ rotuloStatus(r.status) }}</el-tag>
                            </td>
                            <td class="u-text-center">
                                <el-button v-if="ehSmed && r.status === 1" @click="abrirAtendimento(r)" type="success" icon="el-icon-finished" size="mini" plain title="Atender" class="u-mr-10"></el-button>
                                <el-button v-if="r.status === 2" @click="imprimir(r)" type="info" icon="el-icon-printer" size="mini" plain title="Imprimir documento de saída"></el-button>
                                <el-button v-if="ehSmed && r.status === 2" @click="abrirRevisao(r)" type="warning" icon="el-icon-refresh-left" size="mini" plain title="Revisar entrega" class="u-mr-10"></el-button>
                                <router-link :to="`/admin/almox-requisicao/edit/${r.id}`">
                                    <el-button :icon="r.status === 1 ? 'el-icon-edit' : 'el-icon-view'" size="mini" plain :title="r.status === 1 ? 'Editar' : 'Visualizar'" class="u-mr-10"></el-button>
                                </router-link>
                                <el-button v-if="r.status === 1" @click="cancelar(r)" type="warning" icon="el-icon-close" size="mini" plain title="Cancelar"></el-button>
                                <el-button v-if="r.status !== 2" @click="excluir(r)" type="danger" icon="el-icon-delete" size="mini" plain title="Excluir"></el-button>
                            </td>
                        </tr>
                        <tr v-if="statusList && !items.length">
                            <td colspan="6" class="u-text-center" style="color:#909399; padding:12px;">Nenhuma requisição encontrada.</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <el-pagination v-if="paginate.qtdItens > 30" @current-change="load" :current-page.sync="paginate.page"
                :page-size="30" layout="prev, pager, next" :total="paginate.qtdItens" class="u-mt-15"></el-pagination>
        </c-panel>

        <!-- ===================== ATENDIMENTO ===================== -->
        <el-dialog :title="revisao ? 'Revisar entrega' : 'Atender requisição'" :visible.sync="modal" width="70%" :close-on-click-modal="false">
            <div v-if="atual">
                <p class="u-mb-15">
                    <strong>{{ atual.numero }}</strong> — {{ atual.instituicao ? atual.instituicao.nome : '—' }}
                </p>

                <div class="container-table">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th>Produto</th>
                                <th style="width:100px;" class="u-text-center">Requisitado</th>
                                <th style="width:100px;" class="u-text-center">Est. Almox.</th>
                                <th style="width:100px;" class="u-text-center">Est. Unidade</th>
                                <th style="width:100px;" class="u-text-center">{{ revisao ? 'Entregue' : 'Conceder' }}</th>
                                <th style="width:230px;">Motivo</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="it in atendimento" :key="it.item_id">
                                <td>{{ it.rotulo }}</td>
                                <td class="u-text-center">{{ formataQtd(it.solicitado) }}</td>
                                <td class="u-text-center">
                                    <span :class="it.quantidade > it.saldo ? 'saldo-insuficiente' : ''">{{ formataQtd(it.saldo) }}</span>
                                </td>
                                <td class="u-text-center">{{ formataQtd(it.saldo_unidade) }}</td>
                                <td class="u-text-center">
                                    <el-input v-model="it.quantidade" size="mini" style="width:80px;"></el-input>
                                </td>
                                <td>
                                    <!-- Só faz sentido explicar o que não foi mandado por inteiro. -->
                                    <el-select v-model="it.motivo_id" size="mini" clearable filterable
                                        :disabled="!cortou(it)" :placeholder="cortou(it) ? 'Selecione' : ''" style="width:100%;">
                                        <el-option v-for="m in motivos" :key="m.id" :label="m.nome" :value="m.id"></el-option>
                                    </el-select>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <p class="u-mt-10" style="color:#909399; font-size:12px;">
                    <template v-if="revisao">
                        Corrija o que foi realmente entregue. O que voltou com o entregador é estornado:
                        sai da escola e retorna ao almoxarifado.
                    </template>
                    <template v-else>
                        O envio baixa o estoque do almoxarifado e credita na escola. Deixe zero no que não for enviar —
                        e informe o motivo sempre que mandar menos do que foi pedido.
                    </template>
                </p>
            </div>

            <span slot="footer">
                <el-button @click="modal = false">CANCELAR</el-button>
                <el-button type="primary" icon="el-icon-check" @click="confirmar">{{ revisao ? 'CONFIRMAR REVISÃO' : 'CONFIRMAR ENVIO' }}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
/**
 * Requisições ao almoxarifado. A escola vê as suas; a SMED vê todas e é quem
 * atende — informando, item a item, quanto vai enviar.
 */
export default {
    data: () => ({
        statusList: false,
        items: [],
        modal: false,
        revisao: false,
        atual: null,
        atendimento: [],
        motivos: [],
        almoxarifadoId: null,
        // Abre já filtrada nas requisições em aberto: é o que precisa de ação.
        // As demais continuam a um clique, limpando o filtro.
        filtro: { instituicao_id: '', status: 1, data_inicio: '', data_fim: '' },
        paginate: { page: 1, qtdItens: 0 }
    }),
    computed: {
        ehSmed () { return [4, 5, 6, 7, 8, 10].includes(Number(this.$store.state.user.tipo)) },
        /** A store guarda as instituições como objeto; normalizar evita surpresa. */
        listaInstituicoes () {
            const v = this.$store.state.instituicoes
            return Array.isArray(v) ? v : Object.values(v || {})
        }
    },
    mounted () {
        if (!this.ehSmed) this.filtro.instituicao_id = this.$store.state.config.instituicao.id
        this.carregarAlmoxarifado()
        this.carregarMotivos()
        this.load(1)
    },
    methods: {
        baseUrl () { return this.$store.state.config.baseUrlApi },
        auth () { return this.$store.getters.getHeaderAuth },
        aviso (msg) { window.eventBus.$emit('alert', { msg, type: 'warning' }) },
        formataQtd (v) { const n = Number(v) || 0; return n % 1 === 0 ? String(n) : n.toFixed(3) },
        formataData (d) { return d ? this.$moment(d).format('DD/MM/YYYY') : '—' },
        rotuloStatus (s) { return { 1: 'Aberta', 2: 'Atendida', 3: 'Cancelada' }[s] || '?' },
        corStatus (s) { return { 1: 'warning', 2: 'success', 3: 'info' }[s] || 'info' },
        /** Está mandando menos do que foi pedido? */
        cortou (it) {
            const q = Number(String(it.quantidade).replace(',', '.'))
            return !isNaN(q) && q < Number(it.solicitado)
        },

        carregarMotivos () {
            this.$axios.get(`${this.baseUrl()}/api/almox-motivo-recusa/getAll?situacao=true`, this.auth())
                .then(r => { this.motivos = r.data || [] })
                .catch(e => this.$store.commit('throwException', e))
        },
        carregarAlmoxarifado () {
            this.$axios.get(`${this.baseUrl()}/api/almox-requisicao/almoxarifado`, this.auth())
                .then(r => { this.almoxarifadoId = r.data ? r.data.id : null })
                .catch(() => {})
        },
        load (page) {
            this.paginate.page = page || 1
            this.statusList = false

            this.$axios.post(`${this.baseUrl()}/api/almox-requisicao/getAllPaginate?page=${this.paginate.page}`,
                this.filtro, this.auth())
                .then(r => {
                    this.items = (r.data && r.data.data) || []
                    this.paginate.qtdItens = (r.data && r.data.total) || 0
                    this.statusList = true
                })
                .catch(e => { this.statusList = true; this.$store.commit('throwException', e) })
        },

        /* ------------------------- atendimento ------------------------- */
        /**
         * Abre o documento em nova aba. O PDF exige o token, então vem por XHR e
         * vira blob — um link direto seria recusado pela API.
         */
        imprimir (r) {
            window.eventBus.$emit('loading', true)

            this.$axios.get(`${this.baseUrl()}/api/almox-requisicao/documento/${r.id}`,
                Object.assign({ responseType: 'blob' }, this.auth()))
                .then(res => {
                    window.eventBus.$emit('loading', false)
                    window.open(URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' })), '_blank')
                })
                .catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
        },
        abrirRevisao (r) { this.abrirAtendimento(r, true) },
        abrirAtendimento (r, revisao) {
            this.revisao = !!revisao
            window.eventBus.$emit('loading', true)

            this.$axios.get(`${this.baseUrl()}/api/almox-requisicao/getById/${r.id}`, this.auth())
                .then(res => {
                    const reg = res.data || {}
                    this.atual = reg

                    // Os dois saldos (almoxarifado = o que pode mandar; escola = o que ela já tem) vêm com a requisição.
                    this.atendimento = (reg.itens || []).map(it => {
                        const prod = it.produto || {}
                        const saldo = Number(it.saldo_almoxarifado || 0)
                        const solicitado = Number(it.quantidade)

                        return {
                            item_id: it.id,
                            rotulo: `${prod.nome || '(produto removido)'} - ${prod.unidade_medida || 'UN'}`,
                            saldo,
                            saldo_unidade: Number(it.saldo_unidade || 0),
                            solicitado,
                            // Atendendo, sugere o pedido limitado ao estoque; revisando,
                            // parte do que já foi entregue.
                            quantidade: this.revisao ? Number(it.quantidade_atendida || 0) : Math.min(solicitado, saldo),
                            motivo_id: it.motivo_id || null
                        }
                    }).sort((a, b) => a.rotulo.localeCompare(b.rotulo, 'pt-BR', { sensitivity: 'base', numeric: true }))

                    window.eventBus.$emit('loading', false)
                    this.modal = true
                })
                .catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
        },
        confirmar () { return this.revisao ? this.confirmarRevisao() : this.confirmarAtendimento() },
        confirmarRevisao () {
            const itens = this.atendimento.map(it => ({
                item_id: it.item_id,
                quantidade: Number(String(it.quantidade).replace(',', '.')) || 0,
                motivo_id: it.motivo_id || null
            }))

            const semMotivo = this.atendimento.find(it => this.cortou(it) && !it.motivo_id)

            if (semMotivo) { this.aviso(`Informe o motivo do corte em ${semMotivo.rotulo}.`); return }

            window.eventBus.$emit('loading', true)

            this.$axios.post(`${this.baseUrl()}/api/almox-requisicao/revisar/${this.atual.id}`, { itens }, this.auth())
                .then(r => {
                    window.eventBus.$emit('loading', false)
                    if (r.data && r.data.erro) { this.aviso(r.data.erro); return }

                    window.eventBus.$emit('alert', { msg: 'Entrega revisada.', type: 'success' })
                    this.modal = false
                    this.load(this.paginate.page)
                })
                .catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
        },
        confirmarAtendimento () {
            const itens = this.atendimento.map(it => ({
                item_id: it.item_id,
                quantidade: Number(String(it.quantidade).replace(',', '.')) || 0,
                motivo_id: it.motivo_id || null
            }))

            if (!itens.some(i => i.quantidade > 0)) {
                this.aviso('Informe a quantidade a enviar de pelo menos um item.')
                return
            }

            const semMotivo = this.atendimento.find(it => this.cortou(it) && !it.motivo_id)

            if (semMotivo) {
                this.aviso(`Informe o motivo do corte em ${semMotivo.rotulo}.`)
                return
            }

            window.eventBus.$emit('loading', true)

            this.$axios.post(`${this.baseUrl()}/api/almox-requisicao/atender/${this.atual.id}`, { itens }, this.auth())
                .then(r => {
                    window.eventBus.$emit('loading', false)
                    if (r.data && r.data.erro) { this.aviso(r.data.erro); return }

                    window.eventBus.$emit('alert', { msg: 'Requisição atendida com sucesso.', type: 'success' })
                    this.modal = false
                    this.load(this.paginate.page)
                })
                .catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
        },

        cancelar (r) {
            this.$msgbox.confirm('Cancelar esta requisição?', 'Atenção', {
                confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning'
            }).then(() => {
                this.$axios.post(`${this.baseUrl()}/api/almox-requisicao/cancelar/${r.id}`, {}, this.auth())
                    .then(res => {
                        if (res.data && res.data.erro) { this.aviso(res.data.erro); return }
                        window.eventBus.$emit('alert', { msg: 'Requisição cancelada.', type: 'success' })
                        this.load(this.paginate.page)
                    })
                    .catch(e => this.$store.commit('throwException', e))
            }).catch(() => {})
        },
        excluir (r) {
            this.$msgbox.confirm('Excluir esta requisição?', 'Atenção', {
                confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning'
            }).then(() => {
                this.$axios.delete(`${this.baseUrl()}/api/almox-requisicao/delete/${r.id}`, this.auth())
                    .then(res => {
                        if (res.data && res.data.erro) { this.aviso(res.data.erro); return }
                        window.eventBus.$emit('alert', { msg: 'Requisição excluída.', type: 'success' })
                        this.load(this.paginate.page)
                    })
                    .catch(e => this.$store.commit('throwException', e))
            }).catch(() => {})
        }
    }
}
</script>

<style scoped>
.saldo-insuficiente { color: #f56c6c; font-weight: bold; }
</style>
